export default "__VITE_ASSET___L2P6kfR__"